import type { MouseEvent } from "react";

import { IconButton } from "@similarweb/ui-components";

import { useMediaPreviewContext } from "./MediaPreviewContext";
import { FloatingDownloadButton } from "./styledComponents";

interface IMediaPreviewDownloadButtonProps {
    href: string;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export const MediaPreviewDownloadButton = ({ href, onClick }: IMediaPreviewDownloadButtonProps) => {
    const { state } = useMediaPreviewContext();

    if (state.status !== "loaded") {
        return null;
    }

    return (
        <FloatingDownloadButton
            data-automation="media-preview-download-button"
            href={href}
            onClick={onClick}
            download
        >
            <IconButton
                iconName="download"
                type="flat"
            />
        </FloatingDownloadButton>
    );
};
